// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Sm5U","placeHolderShimmer":"styles_placeHolderShimmer__1xV1R","shimmer":"styles_shimmer__1h8GM"};